import { useLocalObservable } from 'mobx-react-lite';

import { useCallContext } from '@gem/call/CallView/CallView.context';

interface IPermissionRequestsButtonPresenter {
  onClick(): void;
  permissionsRequestsCount: number;
}

export const usePermissionRequestsButtonPresenter = (): IPermissionRequestsButtonPresenter => {
  const context = useCallContext();

  return useLocalObservable<IPermissionRequestsButtonPresenter>(() => ({
    onClick(): void {
      if (!context.call.viewState.isMembersShown) {
        context.call.viewState.showMembers();
      }

      context.call.viewState.showPermissionsRequests();
    },

    get permissionsRequestsCount(): number {
      return context.call.permissions.permissionsRequestsCount;
    },
  }));
};
